export default "__VITE_ASSET__c924715e__"